<template>
  <div>
    <banner :isMobile="isMobile"></banner>
    <!-- <banner use="home" :isMobile="isMobile">
      <banner-info slot="info-content" :isMobile="isMobile"></banner-info>
    </banner> -->
    <technicist :isMobile="isMobile"></technicist>

    <power :isMobile="isMobile"></power>

    <location :isMobile="isMobile" :locationTips="locationTips"></location>

    <events :isMobile="isMobile" :events="events"></events>
    <!-- <ego-case :isMobile="isMobile"></ego-case> -->

    <!-- 合作伙伴部分 -->
    <partner></partner>
  </div>
</template>
<script>
import banner from '@/components/banner-new'
// import banner from '@/components/banner'
// import bannerInfo from '@/components/indexBannerInfo'
import technicist from './technicist'
import location from './location'
import events from './events'
import power from './power'
import partner from './partner'
// import egoCase from './case'

import { mapState } from 'vuex'
import weixinshare from '@/util/weixinshare'

export default {
  data () {
    return {}
  },
  components: {
    banner,
    // banner,
    // bannerInfo,
    technicist,
    location,
    events,
    power,
    // egoCase,
    partner
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    }),
    locationTips () {
      return [{
        icon: require('../../assets/img/100.png'),
        text: '100%学员皆为企业 CTO、技术高管'
      }, {
        icon: require('../../assets/img/70.png'),
        text: '70%学员为CTO和技术VP'
      }, {
        icon: require('../../assets/img/33.png'),
        text: '近 3 成学员技术管理年限超 8 年'
      }]
    },
    events () {
      return [{
        imgUrl: 'https://static001.geekbang.org/resource/image/2b/a1/2b74f0159dc3189aa432664020959ba1.png?x-oss-process=image/resize,m_fill,h_400,w_782',
        title: '私密小组活动',
        con: '组内6-8位学员的每月私密聚会，通过案例分享战略、技术、管理等实战心得',
        url: 'https://tgo.infoq.cn/about/global'
      }, {
        imgUrl: 'https://static001.geekbang.org/resource/image/ee/a6/ee1ba8662d06dcccac0ed85921c187a6.png?x-oss-process=image/resize,m_fill,h_400,w_379',
        title: '年度团聚家宴',
        con: 'TGO 鲲鹏会各地区的年终大趴，与家人、学员及学员家属共度轻松时光',
        url: 'https://tgo.infoq.cn/about/global'
      }, {
        imgUrl: 'https://static001.geekbang.org/resource/image/04/36/04d0082a370d42db096c63edc5a1da36.png?x-oss-process=image/resize,m_fill,h_400,w_379',
        title: '月度公开学习活动',
        con: '各地精彩活动，每月都有新鲜主题，促进学员间、学员与企业间学习交流',
        url: 'https://tgo.infoq.cn/about/global'
      }, {
        imgUrl: 'https://static001.geekbang.org/resource/image/92/d5/92adba0fa47c684997939dec1098e9d5.png?x-oss-process=image/resize,m_fill,h_400,w_379',
        title: '全球经验对话',
        con: '学员走出国门，与全球多地技术领导者共同学习与对话，探讨前沿技术趋势',
        url: 'https://tgo.infoq.cn/about/global'
      }, {
        imgUrl: 'https://static001.geekbang.org/resource/image/14/7d/14cccad9c2550fdc06150de42747377d.png?x-oss-process=image/resize,m_fill,h_400,w_379',
        title: '技术高管培训',
        con: 'TGO 使命是助力学员成为卓越的科技领导者，体系化的培训是其中重要的一块基石',
        url: 'https://tgo.infoq.cn/about/global'
      }, {
        imgUrl: 'https://static001.geekbang.org/resource/image/81/de/8181314da59ece632734e5c0608825de.png',
        title: '荣誉导师辅导',
        con: '荣誉导师辅导是帮助全体学员成长的驱动计划，旨在激发学员热情传递成熟经验',
        url: 'https://tgo.infoq.cn/about/global'
      }, {
        imgUrl: 'https://static001.geekbang.org/resource/image/0d/27/0de94a094b9f779f9ea6940e88ce2627.png?x-oss-process=image/resize,m_fill,h_400,w_379',
        title: '全球技术领导力峰会(GTLC)',
        con: '汇聚资深行业专家、联结资深科技领导者，为技术人打造的技术管理交流平台',
        url: 'https://tgo.infoq.cn/about/global'
      }]
    }
  },
  created () {
    window.document.title = '首页 | TGO 鲲鹏会 - 助力学员成为卓越的科技领导者'
  },
  mounted () {
    weixinshare({
      title: 'TGO 鲲鹏会 | 助力学员成为更优秀的科技领导者',
      desc: '构建全球化的有技术背景的科技领导者学习成长平台'
    })
  }
}
</script>
